<div class="comparsionPageWrap">
    <div class="trinkavsGarmmarlyBanner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="bannerContent">
                        <h1>尋找Ginger替代方案？</h1>
                        <p>從Ginger高級套餐切換到Trinka，不會損失訂閱費！</p>
                        <div class="bannerContentButtons try_a_free_form">
                            <!-- <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank" class="itsFreeButton">免費使用Trinka
                            </a>
                            <span class="orTrydemoButton">
                                <a [routerLink]="['/try-a-demo']">
                                    或嘗試一下演示
                                </a>
                            </span> -->
                            <form [formGroup]="compareTrinkaGrammarly" (ngSubmit)="onSubmitEmail()">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group"
                                            [ngClass]="(!compareTrinkaGrammarly.get('userEmailId').valid && compareTrinkaGrammarly.get('userEmailId').dirty) || (compareTrinkaGrammarly.get('userEmailId').touched && compareTrinkaGrammarly.get('userEmailId').pristine) ? 'TextFiledError' : '' ">
                                            <mat-form-field appearance="outline">
                                                <mat-label>輸入電子郵件 *</mat-label>
                                                <input id="contactUserEmail" matInput placeholder="" formControlName="userEmailId" class="form-control">
                                            </mat-form-field>
                                            <button type="submit">免費試用</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="grammarlyTestimonials">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonialsContent">
                    <img src="../../../assets/images/double_quotes_icon.png" alt="quotes icon">
                    <p>與Ginger相比，Trinka捕獲複雜語言和文法錯誤的速度和準確性讓我感到驚訝。Trinka是高級英語文法檢查的完美工具。</p>
                    <h3>流行病學家，澳大利亞</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="switch_from_grammarly custom_width">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>從Ginger高級用戶轉到Trinka高級用戶</h2>
                    <div class="HeadingSubLine"></div>
                    <p>您是否已經訂閱了Ginger高級服務，但正在尋找更好的替代？您可以輕鬆地將您的Ginger高級服務餘額切換到Trinka高級服務！</p>

                    <div class="sample_exmple">
                        <p>
                            <b>Ginger高級套餐年度計畫示例</b>
                        </p>
                        <p>高級套餐開始日期：2021年1月5日</p>
                        <p>今日日期：2021年4月25日</p>
                        <p>您將獲得的額外免費天數：255天</p>
                    </div>
                    <div class="how_it_work">
                        <a (click)="scroll(target)" class="itsFreeButton">使用方式</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="free_premium">
                    <div class="free_premium_border">
                        <div class="discount-label yellow">
                            <span>特別優惠</span>
                        </div>
                        <div class="free_premium_title">
                            免費高級擴展計算器
                        </div>
                        <i>使用此計算器得到您Ginger切換到Trinka能夠獲得的免費高級訂閱的期限。</i>
                        <div class="free_premium_form">
                            <!-- <form> -->
                            <div class="textbox_content form-group">
                                <label>Ginger高級套餐開始日期：</label>
                                <input placeholder="MM/DD/YY" type="date" class="form-control" (change)="premiumDateChanged($event)">
                                <label>計畫類型</label>
                                <select class="custom-select" [ngModel]="grammarlySelect" (change)="planTypeChanged($event)">
                                    <option selected value="">計畫類型</option>
                                    <option value="M">月度</option>
                                    <option value="Y">年度</option>
                                </select>
                            </div>
                            <!-- </form> -->
                            <p *ngIf="finalTextContent" class="form_status">如果您今天購買Trinka高級服務年度計畫，您將獲得
                                <span>{{diffDays}}</span>額外天數。({{currentDate | date:'dd-MM-yyyy'}})
                            </p>

                            <!-- <h3>Example for Grammarly Premium Annual Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 April 2021</p> 
                            <p>Addition free days you will get: 255 days</p> 
                            <h3 class="mart15">Example for Grammarly Premium Monthly Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 January 2021</p> 
                            <p>Addition free days you will get: 20 days</p>  -->
                        </div>
                        <span class="validTextSection">*僅適用於通過信用卡/Debit卡付款</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="compare_tables_discriptions">
                    <h2>Trinka與Ginger的詳細比較</h2>
                    <div class="HeadingSubLine"></div>
                    <p>下表顯示了Trinka如何進行更好的高級英語文法檢查、拼寫檢查、寫作改進，以及比 Ginger 更獨特的專業文法功能。</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <table class="table">
                        <tr>
                            <th>特色</th>
                            <th>Trinka</th>
                            <th>Ginger</th>
                        </tr>
                        <tr>
                            <td>
                                學術風格指南
                                <b>（如APA、AMA等）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                基於學科的更正
                                <b>（醫學、生命科學、工程等）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                技術拼寫
                                <b>（根據學科進行拼寫更正）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                技術用語
                                <b>（寫作適合你的學科）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                一致性檢查
                                <b>（破折號、拼寫、數字等）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                抄襲檢測
                                <b>(對照網路、開放存取和付費出版的內容進行檢查)</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                出版準備檢查
                                <b>（ 透過20 多項檢查評估實現成功出版）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                自動文件編輯
                                <b>（在幾分鐘內自動編輯微軟Word 文件）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                接受或忽略所有更改
                                <b>（一鍵接受或忽略多個建議）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                正式/學術語調
                                <b>（包括口語、非正式短語動詞和習語）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>字數縮減
                                <b>（使寫作簡潔有力）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>無偏見的語言
                                <b>（包容、主動語式、無性別歧視的語言）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>語意模糊
                                <b>（讓你的寫作清晰而具體）</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>引文檢查器
                                <b>(為您的論文引用可信的、有力的引文)。</b>
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="../../../assets/images/closeMark.svg" alt="close icon">
                            </td>
                        </tr>
                        <tr>
                            <td>高級文法檢查</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>句子結構修正</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>詞語選擇</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>美式/英式風格</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>詳細說明和提示</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>個人詞典</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>線上編輯</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>瀏覽器外掛程式</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>
                        <tr>
                            <td>微軟 Word 外掛程式</td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                            <td>
                                <img src="../../../assets/images/checkMarks.svg" alt="check mark icon">
                            </td>
                        </tr>

                    </table>
                </div>
                <div class="disclaimerContainer disclaimerContainer_table">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="disclaimercontents">
                                    <p>我們創建了這些比較圖表，以幫助學生、教授、圖書館員和教育工作者就哪種參考文獻生成器最適合他們的需求做出明智的決定。如果你們發現此圖表中的任何錯誤或者遺漏，請
                                        <a href="mailto:support@trinka.ai">發送電子郵件</a> 給我們，我們會改正。</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="try_trinka_Buttons">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費使用Trinka</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pricing_plan">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="pricing_plan_tables">
                    <h2>定價方案</h2>
                    <div class="HeadingSubLine"></div>
                    <p>比較所有功能並親眼看看結果！Trinka不僅僅是普通的文法檢查器，更是學術和技術寫作的理想工具。</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <div class="pricing_plan_details">
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Trinka
                                        <br>Free</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $0
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/trinka-logo.png" alt="trinka logo" width="136">
                                </div>
                            </div>
                            <ul>
                                <li>高級文法檢查</li>
                                <li>句子結構更正</li>
                                <li>上下文拼寫檢查</li>
                                <li>自動文件編輯</li>
                                <li>書面語氣更正</li>
                                <li>增強寫作影響力</li>
                                <li>技術用詞的選擇</li>
                                <li>選定風格指南</li>
                                <li>一致性檢查</li>
                                <li>抄襲檢測</li>
                                <li>引文檢查器</li>
                                <li>出版準備寫作
                                    <br>
                                    <small>(技術術語, 字數縮減 etc.)</small>
                                </li>
                                <li>期刊出版準備情況
                                    <br>
                                    <small>(期刊範圍檢查, 論文摘要 etc.)</small>
                                </li>
                            </ul>
                        </div>
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Ginger
                                        <br>Premium</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $13.99
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="../../../assets/images/ginger_logo.png" alt="" width="120">
                                </div>
                            </div>

                            <ul>
                                <li>文法和標點符號檢查</li>
                                <li>句子改寫</li>
                                <li>拼寫檢查工具</li>
                                <li>校對</li>
                            </ul>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
<div class="trinkaBetterThanOthers">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="betterThenContent">
                    <h2>Trinka優於頂級文法檢查工具 Ginger 的原因有哪些？</h2>
                    <div class="HeadingSubLine"></div>
                    <p>高級寫作需要高級檢查 -Trinka為您實現這一切！Trinka是基於人工智慧的文法檢查和語言增強工具，專為正式和技術寫作而創建。Trinka具有內置的頂級工具，可檢查您的文法、拼寫和標點符號，並提高您的寫作水準，以最大限度地提高發表機會。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="betterThenImg">
                    <img src="../../../assets/images/BetterThen_img.png" alt="better than ginger">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area document">
                        <h3>學科領域和文件類型</h3>
                    </div>
                    <p>您可以自訂Trinka，讓它根據您的學科領域和手稿類型提供最相關的建議。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guide icon">
                        <h3>預設風格指南</h3>
                    </div>
                    <p>根據流行的學術風格指南（AMA 11th，AGU 2017）定制您手稿的文法和單詞選擇。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/autoFileEdit_icon.svg" alt="auto file edit">
                        <h3>自動文件編輯</h3>
                    </div>
                    <p>上傳您的微軟Word文檔，Trinka能在幾分鐘內完成自動編輯並且讓您下載。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/Icon_PublicationChecks.png" alt="Publication Checks" style="max-width: 30px;">
                        <h3>出版準備檢查</h3>
                    </div>
                    <p>使用Trinka的出版準備檢查，您可以透過從“期刊選擇”到“道德合規”的20多項檢查評估您的文檔，從而增加論文被期刊錄用的機會。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards commingSoonTag">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/ConsistencyCheck_icons.png" alt="consistency-check" style="max-width: 30px;">
                        <h3>一致性檢查</h3>
                    </div>
                    <p>Trinka的一致性檢查可以檢測您寫作中的6種不一致，無論文章長度如何，您都可以進行一鍵修改。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="../../../assets/images/DownloadTrackChangesEdit_icon.png" alt="download track edits" style="max-width: 22px;">
                        <h3>下載追蹤更改文件</h3>
                    </div>
                    <p>您可以下載Trinka提供的追蹤更改文件，它在編輯器中顯示了Trinka提供的各種更改選擇。</p>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="professionalAcademic">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>實現專業的學術和技術文法修正</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <p>Trinka人工智慧能夠執行3000多項文法檢查、語氣和風格增強、高級寫作技巧，更重要的是它可以處理與學術和技術寫作相關的所有學科的作品</p>
                <div class="grammarCorrectionSlide">
                    <!-- <i>原文</i>
                    <p>The beautiful part of this writing assistant, is one it works very fast quickly, <br>secondly second it doesn’t requires does not require any effort from the writer.</p> -->
                    <div class="grammarCorrectionMain">

                        <!-- <div class="sliderHeading">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="sliderLeftSideHeading">
                                    <div class="grammerlyLogo">
                                        <img src="../../../assets/images/grammarly-logo.png" alt="grammarly logo">
                                    </div>
                                    <div class="trinkaCorrections">
                                        <p>The beautiful part of this writing assistant, is one it works very fast quickly, secondly second it doesn’t <b>requires</b>&nbsp; <span>require</span> any effort from the writer.</p> 
                                      </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="sliderRightSideHeading">
                                    <div class="trinkaLogo">
                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo"> 
                                    </div>
                                    <div class="trinkaCorrections">
                                        <p>The beautiful part of this writing assistant, is one it works <b>very fast</b>&nbsp;<span>quickly,</span> secondly second it <b>doesn’t requires</b>&nbsp;<span>does not require</span> any effort from the writer.</p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div> -->
                        <div class="carousel slide" id="keyBenefitContentTwo" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#keyBenefitContentTwo" data-slide-to="0" class="active"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="1"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="2"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="3"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="4"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="5"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="6"></li>
                            </ol>

                            <div class="carousel-inner">

                                <div class="carousel-item active">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Brazilian soils has low levels of phosphorus available, due to high acidity, therefore,
                                            are fundamental the application of phosphate fertilizers for high yields.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus available, due to high acidity,
                                                            therefore, are
                                                            <b>fundamental</b>&nbsp;
                                                            <span>fundamentally</span>&nbsp;the application of phosphate fertilizers
                                                            for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus
                                                            <b>available, due to </b>&nbsp;
                                                            <span>because of</span> high acidity,
                                                            <span>and </span>therefore, are fundamental
                                                            <span>to</span>&nbsp;the application of phosphate fertilizers for high
                                                            yields.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply, is a major cause
                                            of death and affect annually approximately 795,000.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and affect annually approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect annually </b>&nbsp;
                                                            <span>annually affects </span> approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin ratio
                                            (w/w) of 50:1 at 37°C for overnight.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin
                                                            ratio (w/w) of 50:1 at 37°C for overnight.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested
                                                            <b>by</b>&nbsp;
                                                            <span>with</span> trypsin at a protein/trypsin ratio (w/w) of 50:1
                                                            at 37°C
                                                            <b>for</b> overnight.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Belladonna leaves as well as all other studied leaves contains two distinct phosphatase
                                            fraction belonging to types II and III.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves as well as all other studied leaves
                                                            <b>contains</b>&nbsp;
                                                            <span>contain</span> two distinct phosphatase fraction belonging to
                                                            types II and III. </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves
                                                            <b>as well as all</b>&nbsp;
                                                            <span>and </span> other
                                                            <b>studied</b> leaves
                                                            <span>being studied </span>
                                                            <b>contains</b>&nbsp;
                                                            <span>contain</span>&nbsp;two distinct phosphatase
                                                            <b>fraction</b>&nbsp;
                                                            <span>fractions </span>belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>He sees signs of long term starvation, worse even than what he saw in Arkansas.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of long term starvation, worse even than what he saw
                                                            in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation,
                                                            <span>even</span> word
                                                            <b>even</b> than what he saw in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>This kind of political torn-foolery has to a considerable extend prevented our movies
                                            from examining the actual problems of success.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>This kind of political torn-foolery has to a considerable extend
                                                            prevented our movies from examining the actual problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>
                                                            <b>This kind of</b>&nbsp;
                                                            <span>Such</span> political
                                                            <b>torn-foolery</b>&nbsp;
                                                            <span>tomfoolery</span> has to a considerable
                                                            <b>extend</b>&nbsp;
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>The results shows 234 differently expressed proteins (DEP) between GBM to normal
                                            brain tissues.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="../../../assets/images/ginger_logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>&nbsp;
                                                            <span>show</span> 234 differently expressed proteins (DEP) between
                                                            GBM to normal brain tissues.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>&nbsp;
                                                            <span>show</span> 234
                                                            <b>differently</b>&nbsp;
                                                            <span>differentially</span> expressed proteins (
                                                            <b>DEP</b>&nbsp;
                                                            <span>DEPs</span>) between GBM
                                                            <b>to</b>&nbsp;
                                                            <span>and</span>&nbsp;normal brain
                                                            <b>tissues</b>&nbsp;
                                                            <span>tissue</span>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="compare_top_tools">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="top_tools_image">
                    <img src="../../../assets/images/top_tools_compare.png" alt="compare tools">
                </div>
            </div>
            <div class="col-lg-7">
                <div class="top_tools_text_contents">
                    <div class="howItWorkHeading lineWhiteColor">
                        <h3>Trinka與領先的文法檢查工具之間的對比</h3>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <p>Trinka作為真正的Ginger替代品，如何從領先的文法工具中脫穎而出？我們在Grammarly高級版和LanguageTool中測試了來自五個學術領域的5,778個單詞，檢查了對於正式和技術寫作都至關重要的更正準確性、風格指南偏好、簡潔性和上下文拼寫檢查。請參閱我們的獨家白皮書查看詳細比較。
                    </p>
                    <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">
                        下載白皮書
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>高級寫作需要高級檢查。快來認識Trinka吧！</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="meetTrinkaCard">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/GoBeyondGrammar&Spelling.svg" alt="grammar and spelling correction">
                    </div>
                    <h3>不只是文法和拼寫</h3>
                    <p>Trinka不僅僅是一個傳統的文法檢查工具，它還是您的個人寫作助手，幫助您更正其他工具無法檢測到的複雜的正式寫作錯誤。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard unmatched_sections">
                    <div class="meetTrinka_img">

                        <img src="../../../assets/images/UnmatchedWritingEnhancements.svg" alt="enhancements">
                    </div>
                    <h3>無與倫比的寫作增強功能</h3>
                    <p>Trinka可以根據學術出版標準來提高您文章的語調、表達和措辭。
                    </p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard learnAndHelps">
                    <div class="meetTrinka_img">
                        <img src="../../../assets/images/Learns&HelpsYou.svg" alt="learning that helps you">
                    </div>
                    <h3>幫助您成為更好的作者</h3>
                    <p>Trinka提供深入的建議、解釋和寫作技巧，以幫助您學習和提高寫作水準。</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections switchToTrinka padt0" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>從Ginger高級用戶轉到Trinka高級用戶</h2>
                    <div class="HeadingSubLine"></div>
                    <p>您是否已經訂閱了Ginger高級服務，但正在尋找更好的替代？您可以輕鬆地將您的Ginger高級服務餘額切換到Trinka高級服務！</p>
                    <p>立即轉換到Trinka，獲得高級語法更正和許多其他專為學術和技術寫作設計的功能。</p>
                    <p>3個簡單步驟立即完成</p>
                </div>
            </div>
        </div>
        <div class="key_takewaye_sections">
            <h2> 如何進行？</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>1</p>
                        </div>
                        <div class="need_cards_body">
                            <p>按一下
                                <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a> 以創建您的帳戶，您將能夠訪問學術和技術寫作的一系列專有功能。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>2</p>
                        </div>
                        <div class="need_cards_body">
                            <p> 選擇升級以訂閱Trinka高級服務，選擇包年套餐並付款。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>3</p>
                        </div>
                        <div class="need_cards_body">
                            <p>發送郵件到
                                <a href="mailto:support@trinka.ai">support@trinka.ai</a>告知您的Ginger高級帳號詳情，將您的Ginger高級服務餘額轉換為Trinka高級服務。
                            </p>
                            <!-- <p>Share your Writefull Premium transaction details at  to switch your Grammarly Premium balance to Trinka premium.</p> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>使用Trinka開始更好地寫作。</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>免費註冊！</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="other_comparision">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Grammarly</h3>
                    </div>
                    <p>使用Trinka，體驗前所未有的學術寫作協助工具。</p>
                    <a [routerLink]="['/trinka-vs-grammarly']">閱讀更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. LanguageTool</h3>
                    </div>
                    <p>使用Trinka確保整體語言增強。</p>
                    <a [routerLink]="['/trinka-vs-languagetool']">閱讀更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Writefull</h3>
                    </div>
                    <p>使用Trinka更好地與學術寫作慣例和最佳實踐融合。</p>
                    <a [routerLink]="['/trinka-vs-writefull']">閱讀更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="disclaimerContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="disclaimercontents">
                    <p>
                        <span>免責聲明：</span> 上述所有產品和公司名稱均為其各自所有者的商標™或註冊®商標，使用它們並不意味著與它們有任何從屬關係或得到它們的許可。請注意，此處提到的所有比較都是根據產品手冊/網站上提供的產品資訊以及2021年9月15日在相似條件下的實際測試結果。如有任何疑問，請通過
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>與我們聯繫。
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>